module.exports = {
	"general": {
		"accept": "Akzeptieren",
		"add": {
			"attachments": "Anhänge hinzufügen",
			"images": "Bilder hinzufügen",
			"invoiceDocuments": "Fügen Sie Rechnungen und Dokumente hinzu.",
			"file": "Datei hinzufügen",
			"files": "Dateien hinzufügen",
			"filesDocuments": "Dateien und Dokumente hinzufügen"
		},
		"attachment_one": "{{count}} Anhang",
		"attachment_other": "{{count}} Anhänge",
		"attachments": "Anhänge",
		"attachment": {
			"manage": "Anhänge verwalten"
		},
		"back": "Zurück",
		"check": "Überprüfen",
		"claim": "Die mobile Kundendienstsoftware.",
		"comment": "Kommentar",
		"commentYour": "Ihr Kommentar",
		"confirmation": "Bestätigung",
		"contact": "Ansprechpartner",
		"contacts": "Kontakt",
		"customerX": "Kunde X",
		"decline": "Ablehnen",
		"description": "Beschreibung",
		"details": "Details",
		"documents": "Dokumente",
		"document_one": "{{count}} Dokument",
		"document_other": "{{count}} Dokumente",
		"done": "erledigt",
		"edit": "bearbeiten",
		"enter": "Absenden",
		"error": {
			"describe": "Beschreiben Sie den Sachverhalt",
			"transmission": "Fehler bei der Übertragung"
		},
		"escalationManagement": "Eskalationsmanagement",
		"exttechnician": "ext. Techniker",
		"filed": "Abgelehnt",
		"in": {
			"appendix": "im Anhang",
			"report": "im Bericht"
		},
		"imprint": "Impressum & Datenschutzbedingungen",
		"loading": "Lädt",
		"names": "Vorname Nachname",
		"namesFirst": "Zuerst einen Namen eingeben",
		"next": "weiter",
		"noInput": "Keine Eingabe",
		"oclock": "Uhr",
		"orIsIn": "oder befindet sich im",
		"phone": {
			"phone": "Tel.:",
			"mobile": "Mobil:"
		},
		"plus": "zzgl.",
		"rejected": "wurde abgelehnt",
		"report": "Bericht",
		"rework": "Nacharbeit",
		"send": "übermitteln",
		"show": "anzeigen",
		"showPlace": "Ort anzeigen",
		"serviceObject": "Einsatzort",
		"start": "Start",
		"step": {
			"edit": "Schritt bearbeiten",
			"finished": "Sie haben {{stepsFinished}} von {{steps}} Schritten bearbeitet",
			"next": "nächster Schritt",
			"single": "Schritt"
		},
		"transferred": "Übertragen",
		"to": "bis",
		"upload": {
			"progress": "Upload läuft",
			"upload": "hochladen"
		},
		"valueInput": "Werteingabe"
	},
	"job": {
		"accepted": "Auftrag angenommen",
		"cancel": "Auftrag abbrechen",
		"decline": "Auftrag ablehnen",
		"declineReason": "Hiermit lehnen sie den Auftrag ab. Bitte nennen Sie einen Grund:",
		"end": "Auftrag beenden",
		"hold": "Auftrag angehalten",
		"the": "Der Auftrag",
		"send": "Auftrag senden",
		"sent": "Auftrag gesendet"
	},
	"protocol": {
		"final": "Abschlussprotokoll"
	},
	"report": {
		"create": "Erstellen sie ihren Bericht",
		"edit": "Bericht bearbeiten",
		"final": {
			"show": "Abschlussbericht ansehen"
		},
		"generate": "Erstellen Sie Ihren Bericht in <strong>{{apiSteps}} Schritten</strong>",
		"send": "Senden sie ihren Bericht",
		"show": "Abschlussbericht ansehen"
	},
	"signature": {
		"add": "Unterschrift hinzufügen",
		"missing": "Zur Übertragung fehlen noch {signaturesOpen.length} Unterschriften",
		"no": "Leere Unterschrift/Kein Name",
		"now": "Jetzt unterschreiben",
		"onlyNo": "keine Unterschrift vorhanden",
		"open": "Offene Unterschrift",
		"signature": "Unterschrift",
		"signatureTechnichian": "Unterschrift Techniker"
	},
	"enumeration": {
		"done": "Erledigt",
		"rework": "Nacharbeit erforderlich"
	},
	"intlDateTime": "{{val, datetime}}"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/de/translation.json
// module id = 687
// module chunks = 0